"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
(function _() {
  var styles = ".DefaultTitle {\n  background: #444;\n  border-top: 1px solid #5e5e5e;\n  color: #999;\n  font-size: 0.75rem;\n  font-weight: bold;\n  padding: 0.3rem 0.9375rem;\n  text-transform: uppercase;\n  background: linear-gradient(to right, black 0, #444 5px, #444 100%);\n}";
  var fileName = "DefaultTitle_DefaultTitle";
  var element = document.querySelector("style[data-sass-component='DefaultTitle_DefaultTitle']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var DefaultTitle = function DefaultTitle(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("header", {
    className: "DefaultTitle",
    children: children
  });
};
var _default = DefaultTitle;
exports["default"] = _default;